// extracted by mini-css-extract-plugin
export default {"icon":"ResetButton_icon__C48R4"};